import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonComponent } from '@dss-libs/shared/ui/common-components';

@Component({
  selector: 'juno-libs-ui-order-details-skeleton',
  imports: [SkeletonComponent],
  templateUrl: './order-details-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderDetailsSkeletonComponent {}
